import appAction from "./_actions/app.action";
const config = {
  appVersion: "1.0.0",
  appName: "shift-react-boilerplate",
  apiBaseUrl: "http://localhost:3000",
  enviroment: appAction.ENV_DEVELOPMENT,
}
export default config
